import { useState, useEffect } from 'react';
import buscarNodo from '../Hooks/useBuscarNodo';
import useFetchFiltro from '../Hooks/useFetchFiltro';
import moment from 'moment';

const searchEmpleado = buscarNodo('Empleados');
const searchVehiculo = buscarNodo('Vehiculos');
const searchTarifaAvianca = buscarNodo('TarifasAvianca');
const searchCarreteras = buscarNodo('Carreteras');
const searchFlotas = buscarNodo('Flotas');
const searchZonaReparto = buscarNodo('ZonasReparto');
const searchCentroCosto = buscarNodo('CentroCosto');
const searchAreaUsuaria = buscarNodo('areasUsuarias');

const convertirTiempo = (data) => {
    if (data) {
        let fecha = new Date(data);

        let dataR = moment(fecha.getTime()).format("HH:mm");

        return dataR;
    } else {

        return '---';
    }
}

const difKM = (data1, data2) => {
    if (data1 && data2) {
        let a = parseInt(data1);
        let b = parseInt(data2);
        let dif = 0;
        if (b > a) {
            dif = b - a;
        } else if (b == 1) {
            dif = 0;
        }
        else {
            dif = 'N/A';
        }
        return dif;
    } else {
        return '---';
    }
}

const pasajeroDif = (data1, data2, fecha) => {
    if (data2 !== undefined && data2 !== null && data2 !== '---') {
        data1: data1; data1 = '-';
        let timestamp = data1.timestamp;
        let eta = data2.eta;

        let fechatime = new Date(timestamp);

        let newfecha = new Date(fecha.fecha);
        let hora = fecha.horaInicio;

        hora = hora.split(':');
        newfecha.setHours(hora[0]);
        newfecha.setMinutes(hora[1]);

        let fechaDif = moment(timestamp);

        let startDate = moment(newfecha.getTime());
        let endDate = moment(startDate).add(eta, 'minutes').format('HH:mm');

        endDate = endDate.split(':');
        newfecha.setHours(endDate[0]);
        newfecha.setMinutes(endDate[1]);
        timestamp = moment(timestamp);
        let fechaM = moment(newfecha.getTime());
        let diff = timestamp.diff(newfecha.getTime());
        let diffDuration = moment.duration(diff);
        if (fechaM.isBefore(timestamp)) {
            return 0;
        } else {
            let time = moment(diffDuration.hours() + ':' + diffDuration.minutes() + ':' + diffDuration.seconds(), 'HH:mm:ss').format("HH:mm:ss");
            return time;
        }

    }
    else {
        return '---';
    }
}

//Tipo de 
const tipo = (data) => {
    if (data !== undefined && data !== '', data !== null) {
        switch (data) {
            case 'pilotos':
                return 'PO'
            case 'pilotossap':
                return 'PA'
            case 'tcs':
                return 'TCO'
            case 'tcssap':
                return 'TCA'
            case 'persTierr':
                return 'PTO'
        }
    } else {
        return '---';
    }
}

const espera = (data) => {
    if (data) {
        if (data.horaSubida !== undefined && data.horaSubida !== '' && data.horaTimbre !== undefined && data.horaTimbre !== '') {
            let startfecha = moment(data.horaTimbre);
            let endfecha = moment(data.horaSubida);
            let diff = endfecha.diff(startfecha);
            let diffDuration = moment.duration(diff);

            if (endfecha.isBefore(startfecha)) {
                return 0;
            } else {
                let time = moment(diffDuration.minutes() + ':' + diffDuration.seconds(), 'mm:ss').format("mm:ss");
                return time;
            }
        }
        else {
            return '---';
        }
    } else {
        return '---';
    }
}

const timbre = (data) => {
    if (data) {
        if (data.horaTimbre !== 'undefined' && data.horaTimbre !== '') {
            // let fhoraTimbre = new Date(data.horaTimbre);
            data = moment(data, 'HH:mm').format("HH:mm");
            return data;
        } else {
            return '---';
        }
    }
    else {
        return '---';
    }
}

const calcularDiff = (data1, data2, fecha) => {
    if (data1 && data2) {

        let fecha1 = new Date(fecha);
        let split = data1.split(':');

        fecha1.setHours(split[0]);
        fecha1.setMinutes(split[1]);
        fecha1.setSeconds(0);

        let startfecha = moment(fecha1.getTime());
        let endfecha = moment(data2);
        let diff = endfecha.diff(startfecha);
        let diffDuration = moment.duration(diff);
        if (endfecha.isBefore(startfecha)) {
            return 0;
        } else {
            let time = moment(diffDuration.hours() + ':' + diffDuration.minutes() + ':' + diffDuration.seconds(), 'HH:mm:ss').format("HH:mm:ss");
            return time;
        }

    } else {
        return '---';
    }
}

const useProgramacion = (fecha1, fecha2, empresaFiltro, viajeFiltro) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [data, setData] = useState([]);
    const [reporte, setReporte] = useState([]);
    const programacionDia = useFetchFiltro('ProgramacionDia');

    useEffect(() => {
        setIsError(false);
        setIsLoading(false);
        try {
            let fechanow = new Date();
            const fecha = new Date(fechanow.getFullYear() + '/' + (fechanow.getMonth() + 1) + '/' + fechanow.getDate());
            programacionDia.setNodoFiltro('fecha');
            programacionDia.setFiltro(fecha.toString());
        } catch (error) {
            setIsError(true)
        }
        setIsLoading(false);
    }, []);

    useEffect(() => {
        setIsLoading(true);
        setIsError(false)
        try {
            const fecha1Scopped = fecha1;
            const fecha2Scopped = fecha2;
            if ((fecha1 && !fecha2) || (!fecha1 && fecha2)) {
                const strFecha = fecha1Scopped || fecha2Scopped;
                const preFecha = strFecha.split('-');
                const fecha = new Date(preFecha[0] + '/' + preFecha[1] + '/' + preFecha[2]);
                programacionDia.setFiltro(fecha.toString());
            } else if (fecha1 && fecha2) {
                const preFecha1 = fecha1Scopped.split('-');
                const fecha1 = new Date(preFecha1[0] + '/' + preFecha1[1] + '/' + preFecha1[2]);
                const moment1 = moment(fecha1);

                const preFecha2 = fecha2Scopped.split('-');
                const fecha2 = new Date(preFecha2[0] + '/' + preFecha2[1] + '/' + preFecha2[2]);
                const moment2 = moment(fecha2);

                const diferencia = moment2.diff(moment1, 'd');

                const fechas = [];
                for (let i = 0; i < diferencia + 1; i++) {
                    const nuevaFecha = !i ? moment1 : moment1.add(1, 'd');
                    const fecha = new Date(nuevaFecha.year(), nuevaFecha.month(), nuevaFecha.date()).toString();
                    fechas.push(fecha);
                }
                programacionDia.setFiltro(fechas);
            }
            setIsLoading(false);
        } catch (error) {
            console.log('error :', error);
            setIsError(true)
        }
        setIsLoading(false);

    }, [fecha1, fecha2]);

    const formatTime = value => {
        if (value == '---') return '---';

        const arrayTime = value.split(':');
        return moment().hour(Number(arrayTime[0])).minute(Number(arrayTime[1])).format('HH:mm');
    }

    try {
        useEffect(() => {
            (async () => {
                setIsError(false);
                setIsLoading(true);
                if (programacionDia && programacionDia.data.length) {
                    const array = [];
                    const pasajeroArray = [];
                    const promises = [];
                    for (const item of programacionDia.data) {
                        const promise = new Promise(async (resolve, reject) => {

                            let pasajeroAbordado = 0;
                            let nombreConductor = '';
                            let nombreCarretera = '';
                            let horaLlegadaItinerada = '';
                            let horaInicioItinerada = '';
                            let tiempoRealRecorrido = '';
                            let costo = '';
                            let diff = '';
                            let noEquipo = '';
                            let centroDeCosto = '';
                            let comentario = '';
                            let areaUsuaria = '';
                            let entrenamiento = ''
                            let nombreFlota = '';
                            let totalPasajeros = 0;
                            let zona = '';
                            let tipoTrayecto = '';
                            let kmInicial = '';
                            let kmFinal = '';
                            let difKm = 0;
                            let velocidadMaxima = '';
                            let velocidadPromedio = '';
                            let tipoViaje = '';
                            let fecha = '';
                            let servicio = '';
                            let horaLlegadaReal = '';
                            let horaInicioReal = '';
                            let tarifa = '---';
                            let horaSubida = '---';
                            let pasajeroSubio = '---';
                            let checkpointsA = '';
                            let paradas = '';
                            let paradasA = '';
                            let paradasLenght = '';
                            let solicitante = '';
                            let tipoDeViaje = '';
                            let vScanner = '';
                            let vConductor = '';
                            let estado = '';
                            let inicio = '';
                            let finalizo = '';
                            let fecha_item = '';

                            const conductorPromise = searchEmpleado(item.conductor);
                            const vehiculoPromise = searchVehiculo(item.vehiculo);
                            item.rutaF && item.rutaF.tarifa ? tarifa = item.rutaF.tarifa : tarifa = '---';
                            const tarifaAviancaPromise = searchTarifaAvianca(tarifa);
                            const carreteraPromise = searchCarreteras(item.carretera);
                            item.programacionF && item.programacionF.flota ? nombreFlota = item.programacionF.flota : nombreFlota = '---';
                            const flotaPromise = searchFlotas(nombreFlota);
                            item.rutaF && item.rutaF.zona ? zona = item.rutaF.zona : zona = '---';
                            const zonaRepartoPromise = searchZonaReparto(zona);
                            const centroCostoPromise = searchCentroCosto(item.centroC);

                            const result = await Promise.all([conductorPromise, vehiculoPromise, tarifaAviancaPromise, carreteraPromise, flotaPromise, zonaRepartoPromise, centroCostoPromise]);
                            const [conductor, vehiculo, tarifaAvianca, carretera, flota, zonaReparto, centroCosto] = result;
                            const areaUsuariaConductor = await searchAreaUsuaria(tarifaAvianca.areaU);


                            try {
                                vehiculo ? noEquipo = vehiculo.movil + ' ' + vehiculo.modelo + ' ' + vehiculo.placa : noEquipo = '---';
                                conductor ? nombreConductor = conductor.nombre : nombreConductor = '---';
                                carretera && carretera.valor ? nombreCarretera = carretera.valor : nombreCarretera = '---';
                                areaUsuariaConductor && areaUsuariaConductor.nombre ? areaUsuaria = areaUsuariaConductor.nombre : areaUsuaria = '---';
                                item.horaLlegada ? horaLlegadaItinerada = item.horaLlegada : horaLlegadaItinerada = '---';
                                item.horaInicio ? horaInicioItinerada = item.horaInicio : horaInicioItinerada = '---';
                                item.programacionF && item.programacionF.entrenamiento ? entrenamiento = item.programacionF.entrenamiento : entrenamiento = '---';
                                flota ? nombreFlota = flota : nombreFlota = '---';
                                item.Pasajeros ? totalPasajeros = item.Pasajeros.length : totalPasajeros = 0;
                                zonaReparto ? zona = zonaReparto.zona : zona = '---';
                                item.rutaF && item.rutaF.orden ? tipoTrayecto = 'Recogimiento' : tipoTrayecto = 'Reparto';
                                item.kmInicial ? kmInicial = item.kmInicial : kmInicial = '---';
                                item.kmFinal ? kmFinal = item.kmFinal : kmFinal = '---';
                                item.comentario ? comentario = item.comentario : comentario = '---';
                                centroCosto ? centroDeCosto = centroCosto.codigo : centroDeCosto = '---';
                                tarifaAvianca && vehiculo ? costo = tarifaAvianca.valores[vehiculo.tipo_vehiculo] : costo = '---';
                                item.vMax ? velocidadMaxima = item.vMax : velocidadMaxima = 0;
                                item.vProm ? velocidadPromedio = item.vProm : velocidadPromedio = 0;
                                tarifaAvianca && tarifaAvianca.tipo ? tarifa = tarifaAvianca.tipo : tarifa = '---';
                                item.checkpoints ? checkpointsA = item.checkpoints : checkpointsA = '';
                                item.rutaF && item.rutaF.paradas ? paradasA = item.rutaF.paradas : paradasA = '';
                                item.programacionF && item.programacionF.solicitante ? solicitante = item.programacionF.solicitante : solicitante = '---';
                                item.programacionF && item.programacionF.tipo ? tipoDeViaje = item.programacionF.tipo : tipoDeViaje = '---';
                                item.vscanner ? vScanner = item.vscanner : vScanner = '---';
                                item.vconductor ? vConductor = item.vconductor : vConductor = '---';
                                paradas ? paradasLenght = paradas.length : paradasLenght = 0;
                                item.estado ? estado = item.estado : estado = '---';
                                item.inicio ? inicio = item.inicio : inicio = '0';
                                item.finalizo ? finalizo = item.finalizo : finalizo = '0';
								item.fecha ? fecha_item = item.fecha : fecha_item = '0'; 
								item.comentarioAdmin

                                horaInicioReal = convertirTiempo(inicio);
                                horaLlegadaReal = convertirTiempo(finalizo);
                                let fechaN = new Date(fecha_item);
                                fecha = moment(fechaN.getTime()).format('DD-MM-YYYY');
                                diff = calcularDiff(item.horaLlegada, finalizo, fecha_item);
                                servicio = calcularDiff(horaInicioItinerada , inicio, fecha_item);

                                if (kmInicial && kmFinal) {
                                    let a = parseInt(kmInicial);
                                    let b = parseInt(kmFinal);
                                    difKm = 0;
                                    if (b > a) {
                                        difKm = b - a;
                                    } else if (b == 1) {
                                        difKm = 0;
                                    }
                                    else {
                                        difKm = '---';
                                    }
                                } else {
                                    difKm = '---';
                                }

                                if (fecha !== '---') {
                                    let sub = '' + fechaN.getFullYear() + '';
                                    sub = sub.substring(2, 4);
                                    tipoViaje = tipo(tipoDeViaje);
                                    tipoViaje = tipoViaje !== undefined ? tipoViaje : '';
                                    tipoViaje = tipoViaje + " " + fechaN.getDate() + (fechaN.getMonth() + 1) + sub;
                                    let hora = horaInicioItinerada;
                                    let splitH = hora.split(':');
                                    hora = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
                                    let militar = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HHmm');
                                    vehiculo && vehiculo.movil ? tipoViaje = tipoViaje + ' ' + militar + ' ' + vehiculo.movil : tipoViaje = tipoViaje + ' ' + militar;
                                }

                                if (inicio && finalizo) {
                                    let startfecha = moment(inicio);
                                    let endfecha = moment(finalizo);
                                    let diff = endfecha.diff(startfecha);
                                    let diffDuration = moment.duration(diff);
                                    tiempoRealRecorrido = moment(diffDuration.hours() + ':' + diffDuration.minutes() + ':' + diffDuration.seconds(), 'HH:mm:ss').format("HH:mm:ss");
                                }
                                else {
                                    tiempoRealRecorrido = '---';
                                }
                                
                                if (item.Pasajeros && Array.isArray(item.Pasajeros)) {
                                    for (const pasajero of item.Pasajeros) {
                                        let nombrePasajero = '---';
                                        let areaUsuariaPasajero = '---';
                                        let centroCostoPasajero = '---';
                                        let numeroEmpleado = '---';
                                        let coordenadas = '---';
                                        let escalafon = '---';
                                        let toqueTimbre = '---';
                                        let horaDiff = '';
                                        let checkpoints = '';
                                        let paradas = '';
                                        let largo = 0;
                                        
                                        pasajero && pasajero.escalafon ? escalafon = pasajero.escalafon : escalafon = '---';
                                        pasajero && pasajero.subio ? pasajeroSubio = 'Si' : pasajeroSubio = 'No';
                                        pasajero && pasajero.horaSubida ? horaSubida = convertirTiempo(pasajero.horaSubida) : horaSubida = '---';
                                        if (pasajero && pasajero.centroCosto) {
                                            centroCostoPasajero = await searchCentroCosto(pasajero.centroCosto);
                                            centroCostoPasajero = centroCostoPasajero.codigo;
                                        } else {
                                            centroCostoPasajero = '---'
                                        }
                                        pasajero && pasajero.nombre ? nombrePasajero = pasajero.nombre : nombrePasajero = '---';
                                        pasajero && pasajero.areaU ? areaUsuariaPasajero = pasajero.areaU : areaUsuaria = '---';
                                        pasajero && pasajero.coordenadas ? coordenadas = 'Lat: ' + pasajero.coordenadas.lat + ' Long: ' + pasajero.coordenadas.lng : coordenadas = '---';
                                        pasajero && pasajero.numero_empleado ? numeroEmpleado = pasajero.numero_empleado : numeroEmpleado = '---';

                                        if (escalafon > 0) {
                                            toqueTimbre = pasajero.horaTimbre;

                                            horaDiff = espera(pasajero);
                                            toqueTimbre = timbre(toqueTimbre);
                                        } else if (escalafon <= 0) {

                                            if (checkpoints !== '---' && paradas !== '---') {
                                                checkpoints = checkpointsA[largo];
                                                paradas = paradasA[largo];
                                                let dif = pasajeroDif(checkpoints, paradas, item);
                                                horaDiff = dif;
                                                if (checkpoints !== '---') {
                                                    if (!checkpoints) {
                                                        checkpoints = '-';
                                                        let fechaCheck = moment(checkpoints.timestamp).format('HH:mm');
                                                        toqueTimbre = fechaCheck;
                                                    }
                                                }
                                                else {
                                                    toqueTimbre = '---';
                                                }
                                            }
                                            largo = largo + 1;
                                        }
                                        else {
                                            toqueTimbre = '---';
                                            horaDiff = '---';
                                        }
                                        pasajeroAbordado++;

                                        pasajeroArray.push({
                                            programacionDia: item.key,
                                            tipoViaje: tipoViaje,
                                            fecha: fecha,
                                            nombre: nombrePasajero,
                                            pasajeroAbordado: pasajeroAbordado,
                                            horaSubida: horaSubida,
                                            pasajeroSubio: pasajeroSubio,
                                            centroCostoPasajero: centroCostoPasajero,
                                            areaUsuariaPasajero: areaUsuariaPasajero,
                                            coordenadas: coordenadas,
                                            numeroEmpleado: numeroEmpleado,
                                            toqueTimbre: toqueTimbre,
                                            horaDiff: horaDiff
                                        })
                                    }
                                } else {
                                    let nombrePasajero = '---';
                                    let areaUsuariaPasajero = '---';
                                    let centroCostoPasajero = '---';
                                    let numeroEmpleado = '---';
                                    let coordenadas = '---';
                                    let toqueTimbre = '---';
                                    let horaDiff = '---';

                                    pasajeroArray.push({
                                        programacionDia: item.key,
                                        tipoViaje: tipoViaje,
                                        fecha: fecha,
                                        nombre: nombrePasajero,
                                        pasajeroAbordado: pasajeroAbordado,
                                        horaSubida: horaSubida,
                                        pasajeroSubio: pasajeroSubio,
                                        centroCostoPasajero: centroCostoPasajero,
                                        areaUsuariaPasajero: areaUsuariaPasajero,
                                        coordenadas: coordenadas,
                                        numeroEmpleado: numeroEmpleado,
                                        toqueTimbre: toqueTimbre,
                                        horaDiff: horaDiff
                                    })
                                }
                            } catch (error) {
                                setIsError(true);
                                reject(error);
                                console.log(error);
                            }

                            array.push({
								key: item.key,
								timeStampLiberado: item.timeStampLiberado,
                                estado: estado,
                                conductor: nombreConductor,
                                areaUsuaria: areaUsuaria,
                                entrenamiento: entrenamiento,
                                flota: nombreFlota,
								ruta: tarifa,
                                pasajerosProgramados: totalPasajeros,
                                pasajerosAbordados: pasajeroAbordado,
                                zona: zona, 
                                tipoTrayecto: tipoTrayecto,
                                kmInicial: kmInicial,
                                kmFinal: kmFinal,
                                difKm: difKm,
                                carretera: nombreCarretera,
                                comentario: comentario,
								comentarioAdmin:item.comentarioAdmin,
                                centroCosto: centroDeCosto,
                                equipo: noEquipo,
                                horaLlegadaItinerada: formatTime(horaLlegadaItinerada),
                                horaInicioItinerada: formatTime(horaInicioItinerada),
                                horaInicioReal: formatTime(horaInicioReal),
                                horaLlegadaReal: formatTime(horaLlegadaReal),
                                tiempoRealRecorrido: tiempoRealRecorrido,
                                fecha: fecha,
                                servicio: servicio,
                                costo: costo,
                                diff: diff,
                                velocidadMaxima: velocidadMaxima,
                                velocidadPromedio: velocidadPromedio,
                                tipoViaje: tipoViaje,
                                solicitante: solicitante,
                                vConductor: vConductor,
                                vScanner: vScanner
                            });
                            resolve();
                        })
                        promises.push(promise);
                    }

                    const result = await Promise.all(promises);

                    let dataReporte = array;
                    if (viajeFiltro) {
                        dataReporte = dataReporte.filter(datoFiltrado => datoFiltrado.estado === viajeFiltro);
                    }

                    if (empresaFiltro) {
                        dataReporte = dataReporte.filter(datoFiltrar => datoFiltrar.solicitante === empresaFiltro);
                    }

                    dataReporte.sort((a, b) => {
                        const fechaA = a.fecha.split('-');
                        const fechaB = b.fecha.split('-');
                        const timeA = a.horaInicioItinerada.replace(':', '');
                        const timeB = b.horaInicioItinerada.replace(':', '');


                        return parseInt(fechaA[0] + fechaA[1] + fechaA[2] + timeA) - parseInt(fechaB[0] + fechaB[1] + fechaB[2] + timeB);
                    });

                    setData(dataReporte);

                    let dataPasajero = pasajeroArray.filter(item => {
                        for (const itemReporte of dataReporte) {
                            if (item.programacionDia == itemReporte.key) return true;
                        }
                    });

                    dataPasajero.sort((a, b) => {
                        const arrayDataA = a.tipoViaje.split(' ');
                        const arrayDataB = b.tipoViaje.split(' ');

                        return parseInt(arrayDataA[1] + arrayDataA[2]) - parseInt(arrayDataB[1] + arrayDataB[2])
                    })
                    setReporte(dataPasajero);
                }
                setIsLoading(false);
            })();
        }, [programacionDia.data, viajeFiltro, empresaFiltro]);
    } catch (error) {
        console.log('error ', error);
    }

    return { isLoading, isError, data, reporte };
}

export default useProgramacion;


// WEBPACK FOOTER //
// ./src/Components/Hooks/useProgramacion.js